import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

@Injectable()
export class DiscardAggregateService extends ApiService {
  constructor(private http: Http) {
    super('api/discards-report/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/discard-aggregate.service.ts